<template>
  <div class="bg-wrapper">
    <div class="annotation position-relative">
      <MDBRow>
        <MDBCol :class="id" md="12">
          <p>
            <strong v-html="i18n.value('copy_upper_' + id)"/>
          </p>
          <video controls>
            <source :src="videoSrc" type="video/mp4"/>
          </video>
          <p v-html="i18n.value('copy_lower_' + id)"/>
        </MDBCol>
      </MDBRow>
    </div>
  </div>
</template>

<script>
import { inject } from 'vue'
import { mapGetters, mapMutations } from 'vuex'

import {
  MDBCol,
  MDBRow
} from '@/index.pro.js'

export default {
  components: {
    MDBCol,
    MDBRow
  },
  computed: {
    hotspot () {
      for (const hotspot of this.getHotspots) {
        if (hotspot.id === this.id) {
          return hotspot
        }
      }
      return {}
    },
    videoSrc () {
      return 'mp4/' + this.id + '.mp4'
    },
    ...mapGetters([
      'getHotspots'
    ])
  },
  methods: {
    close () {
      this.$router.back()
    },
    ...mapMutations([
      'setShowAnnotation'
    ])
  },
  name: 'Annotation',
  props: {
    id: String
  },
  setup () {
    const i18n = inject('i18n')
    return { i18n }
  },
  unmounted () {
    this.setShowAnnotation(false)
  }
}
</script>

<style lang="scss">
h5.modal-title {
  color: var(--mdb-primary);
  font-size: 2.1rem;
  font-weight: 800;
  width: 100%;
}

.annotation {
  font-size: 1rem;
  height: 100%;
  padding: 0 2em;

  h1 {
    font-size: 1.3rem;
    font-weight: 800;
    color: var(--mdb-primary);
    margin-bottom:10px;
  }

  img {
    margin: 1em 0;
    width: 100%;
  }

  p {
    padding-right: 3.5rem;
  }

  strong {
    font-size: 1.1rem;
  }

  video {
    width: 100%;
  }

  .Mobile {
    video {
      width: 43%;
    }
  }

  .row > * {
    padding-left: 0;
  }

  .nav-link.active {
    background-repeat: no-repeat!important;
    background-size: contain!important;
    border:0;
    width:305px;
    z-index:50;
  }

  .nav-tabs .nav-link.active, .nav-tabs .nav-item.show {
      color: #ffffff;
      border:0;
      background-color: transparent;
  }

  .nav-link {
    background-repeat: no-repeat!important;
    background-size: contain!important;
    border:0;
    width:305px;
  }
  #tab-resources{margin-left:-100px;}
}

.bg-wrapper {
  height: 100%;
}

.modal-dialog {
  margin-right: 0;
  width: 43vw;
}

.modal-content {
  width: 100%;
  right: 3vw;
  top: 2vw;
}

.modal-body {
  padding-top: 0;
}

.modal-fullscreen .modal-content {
  background-color: rgba(255, 255, 255, 0.95);
  margin: 0 2%;
  width: 60%;
  height: 80vh;
}

.modal-header {
  border: 0;
  padding-left: 2em;
}

.rounded {
  border-radius: 20px!important;
  padding: 0.625rem 2rem 0.5rem 2rem!important;
  margin-bottom:20px!important;
}

.status .fa-thin {
  margin-right: 1em;
}
</style>
